import React from "react";
import Typography from '@mui/material/Typography';

// Component to display common section title and description.
// If description is passed in as an empty string, it will not display a SectionDescription.  Else it will display the description and include line breaks where necessary.
// We use conditional rendering statement using the logical AND (&&) operator to check if descriptionLength is greater than 0.
// We also use a React Fragment to wrap and display the mixed elements of br's with the section description.
const DisplaySectionTitleAndDescription = (props) => {
    
    const { sectionTitle, sectionDescription, isAdminPage } = props;        
    const descriptionLength = sectionDescription?.length || 0;

    // The section title color will change if we are an Admin Page - to tell the Admin User via identification of the color of the section title.
    // Admin page title will be "red".  Otherwise no background will be set for the section title.
    const sectionTitleStyle = {
        backgroundColor: isAdminPage ? '#FDECEF' : 'transparent',
        color: isAdminPage ? '#8A1538' : 'inherit',
        border: isAdminPage ? '1px solid #E8A7B5' : 'none',
        borderRadius: isAdminPage ? '10px' : 0,
        padding: isAdminPage ? 8 : 0,
        marginBottom: isAdminPage ? 12 : 0,
      };
        
    return (                
        <div style={{ marginBottom: isAdminPage ? 20 : 0 }}>
            <Typography variant="h4" component="h1" style={sectionTitleStyle}>{ sectionTitle }</Typography>
                {descriptionLength > 0 && (
                    <Typography
                        component="p"
                        color="text.secondary"
                        sx={{ mt: 1.25, mb: 0, maxWidth: 1120, lineHeight: 1.65 }}
                    >
                        {sectionDescription}
                    </Typography>
                )}
        </div>        
      );
 };

 export default DisplaySectionTitleAndDescription;
